import { BadgeCheck } from "lucide-react";
import { BentoGrid } from "@/components/ui/bento-grid";
import {
  Section,
  SectionContainer,
  SectionHeader,
  SectionTitle,
  SectionDescription,
  SectionContent,
} from "@/components/ui/section";

const certificates = [
  {
    id: 1,
    title: "The Web Developer Bootcamp 2023",
    issuer: "Udemy",
    icon: <BadgeCheck />,
    instructor: "Colt Steele",
    date: "21 maja 2023",
    hours: "74 godz. łącznie",
    description:
      "Comprehensive web development program covering HTML, CSS, JavaScript, Node.js, and more.",
    skills: ["HTML5", "CSS3", "JavaScript", "Node.js", "Express", "MongoDB"],
    certificateId: "UC-b96c92a7-edea-41ab-82d8-311b5b2d1311",
    certificateUrl: "ude.my/UC-b96c92a7-edea-41ab-82d8-311b5b2d1311",
  },
  {
    id: 2,
    title: "The Complete Full-Stack Web Development Bootcamp",
    issuer: "Udemy",
    icon: <BadgeCheck />,
    instructor: "Dr. Angela Yu",
    date: "April 2, 2025",
    hours: "61.5 total hours",
    description:
      "Advanced full-stack web development course covering React, modern JavaScript frameworks, and backend technologies.",
    skills: ["React", "Redux", "Node.js", "Express", "MongoDB", "RESTful APIs"],
    certificateId: "UC-abfd75dd-d2e9-4d44-ad8f-97af467f99ad",
    certificateUrl: "ude.my/UC-abfd75dd-d2e9-4d44-ad8f-97af467f99ad",
  },
];

const Certificates = () => {
  return (
    <Section id="certificates">
      <SectionContainer>
        <SectionHeader>
          <SectionTitle>Certificates & Achievements</SectionTitle>
          <SectionDescription>
            Continuous learning and skill development are at the core of my
            professional journey.
          </SectionDescription>
        </SectionHeader>

        <SectionContent>
          <BentoGrid items={certificates} variant="certificate" columns={2} />
        </SectionContent>
      </SectionContainer>
    </Section>
  );
};

export default Certificates;
